/**
   * Converts a number in seconds to a string of descriptive time in the biggest units
   *
   * @param {number} secondsTime to parse
   * @param {boolean} hideSeconds to not show seconds in final string
   */
export function getDescriptiveTime (secondsTime, hideSeconds = false) {
  const ONE_MIN = 60;
  const ONE_HOUR = 60 * ONE_MIN;
  const ONE_DAY = 24 * ONE_HOUR;

  const seconds = secondsTime % ONE_MIN;
  const minutesTime = secondsTime - seconds;
  const minutes = (minutesTime % ONE_HOUR) / ONE_MIN;
  const hoursTime = minutesTime - (minutes * ONE_MIN);
  const hours = (hoursTime % ONE_DAY) / ONE_HOUR;
  const daysTime = hoursTime - (hours * ONE_HOUR);
  const days = daysTime / ONE_DAY;

  const numFormat = new Intl.NumberFormat(["pt-BR"], {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format;

  const descriptiveParts = [
    { value: days, unit: ["dia", "dias"] },
    { value: hours, unit: ["hora", "horas"] },
    { value: minutes, unit: ["minuto", "minutos"] },
    { value: hideSeconds ? 0 : seconds, unit: ["segundo", "segundos"] }
  ]
    .filter(({ value }) => Math.floor(value) > 0)
    .map(({ value, unit: [one, multiple] }) => `${numFormat(Math.floor(value))} ${value === 1 ? one : multiple}`);

  if (descriptiveParts.length > 1) {
    descriptiveParts.splice(
      descriptiveParts.length - 2,
      2,
      [
        descriptiveParts[descriptiveParts.length - 2],
        descriptiveParts[descriptiveParts.length - 1]
      ].join(" e ")
    );
  }

  const descriptive = descriptiveParts.join(", ").trim();

  return descriptive.length ? descriptive : "Agora";
}
